import { geosSchema } from '@/common/schemas/geo.schema'
import { isAfter, isValid, parse } from 'date-fns'
import { z } from 'zod'

export const updateContractGeneralInformationSchema = z.object({
  contract: z.object({
    in_effect_until: z.string({ message: 'Data de validade é obrigatória' }).refine(
      (value) => {
        if (!value) return false

        const parsedDate = parse(value, 'dd/MM/yyyy', new Date())

        if (!isValid(parsedDate)) {
          return false
        }

        const today = new Date()

        return isAfter(parsedDate, today)
      },
      { message: 'Data deve ser válida e superior à hoje' },
    ),
    geo_geoables: z.array(geosSchema).optional(),
  }),
})

export type UpdateContractGeneralInformationSchema = z.infer<typeof updateContractGeneralInformationSchema>
